import { z } from "zod";

import { PRONOUNS } from "~/patients/constants/constants";
import { RELATIONSHIPS } from "~/patients/constants/relationships";

export const pronounOptionsSchema = z.nativeEnum(PRONOUNS);
export const relationshipOptionsSchema = z.nativeEnum(RELATIONSHIPS);
